if (!customElements.get("nss-collection")) {
    customElements.define(
        "nss-collection",
        class NSSCollection extends HTMLElement {
            constructor() {
                super();

                this.selectors = {
                    toggle: ".js-nss-collection-layout-toggle"
                };
            }

            connectedCallback() {
                this.toggles = this.querySelectorAll(this.selectors.toggle);
                this.toggles.forEach((toggle) => {
                    toggle.addEventListener("click", () => {
                        const col = toggle.getAttribute('data-col');
                        this.setAttribute('data-col', col);
                        this.toggles.forEach((toggleItem) => {
                            toggleItem.classList.remove('is-active');
                        });
                        toggle.classList.add('is-active');
                    });
                })

            }
        }
    );
}
